import React from 'react';
import { Location } from '../../types';

interface MobileBottomSheetProps {
  location: Location;
  isAnimating: boolean;
  onLocationClick?: (location: Location) => void;
  onHide: () => void;
}

export const MobileBottomSheet: React.FC<MobileBottomSheetProps> = ({
  location,
  isAnimating,
  onLocationClick,
  onHide
}) => {
  return (
    <div className="fixed inset-0 z-50 pointer-events-none lg:hidden">
      <div 
        className={`absolute inset-0 bg-black/30 pointer-events-auto transition-opacity duration-300 ${
          isAnimating ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={onHide}
      />
      
      <div className={`absolute bottom-0 left-0 right-0 bg-white rounded-t-3xl shadow-2xl pointer-events-auto max-h-[50vh] overflow-hidden transform transition-all duration-300 ease-out ${
        isAnimating ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}>
        <div className="flex justify-center pt-4 pb-2">
          <div className="w-12 h-1.5 bg-gray-300 rounded-full" />
        </div>
        
        <div className="px-4 pb-6">
          {location.images && location.images.length > 0 && (
            <div className="w-full h-32 rounded-xl overflow-hidden mb-4 bg-gray-100">
              <img
                src={location.images[0]}
                alt={location.name}
                className="w-full h-full object-cover"
              />
            </div>
          )}
          
          <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2 leading-tight">
            {location.name}
          </h3>
          
          <p className="text-sm text-gray-600 mb-6 line-clamp-3 leading-relaxed">
            {location.shortDescription}
          </p>
          
          <button 
            onClick={() => {
              if (onLocationClick) {
                onLocationClick(location);
              }
              onHide();
            }}
            className="w-full bg-primary text-white py-4 rounded-2xl font-bold text-lg hover:bg-primary/90 transition-all duration-200 transform active:scale-95 shadow-lg"
          >
            Падрабязней
          </button>
        </div>
      </div>
    </div>
  );
};